import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  mb, px, pt, pb, m, p, mt
} from 'styled-components-spacing';
import theme from '@theme';

export const StyledCoverMaxWidthWrapper = styled.div`
  max-width: 1400px;
  margin: auto;
  position: relative;
  ${pb(4)}
  ${breakpoint('desktop')`
    ${px(3)}
  `}
`;
export const StyledCover = styled.div`
  width: 100%;
  ${pt(4)}
`;

export const StyledHeading = styled.h1`
  font-weight: 700;
  font-size: 24px;
  color: ${theme.colors.mediumGray};
  text-align: center;
  line-height: 1.4;
  ${px(3)}
  ${mb(3)}
  ${mt(3)}
  ${breakpoint('mobile', 'desktop')`
    font-size: 18px;
  `}
`;

export const StyledFlowCards = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${breakpoint('mobile', 'desktop')`
    flex-direction: column;
  `}
  @media (min-width: 550px) and (max-width: 1024px){
    max-width: 550px;
    margin: auto;
  }
`;

export const StyledCard = styled.div`
  background-color: #f3f5f7;
  border-radius: 12px;
  display: flex;
  ${m(3)}
  ${p(3)}
  width: 50%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  justify-content: space-around;
  ${({ last }) => last && `
    background-color: #0C73D4;
    color: white;
  `}
  ${breakpoint('mobile', 'desktop')`
    width: auto;
    ${pt(3)}
    flex-direction: column;
  `}
`;


export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  ${breakpoint('mobile', 'desktop')`
    flex-direction: row;
    width: auto;
    align-items: center;
  `}
`;

export const StyledText = styled.h1`
  width: 90%;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.2;
  ${breakpoint('mobile', 'desktop')`
    width: auto;
    font-size: 16px;
    padding-left: 10px;
`}
`;

export const StyledSubText = styled.h3`
  width: 90%;
  font-size: 20px;
  ${pt(4)}
  font-weight: 500;
  line-height: 1.2;
  ${breakpoint('mobile', 'desktop')`
    width: auto;
    ${pt(3)}
    font-size: 16px;
  `}
`;

export const StyledCount = styled.img`
  height: 70px;
  width: 65px;
  ${breakpoint('mobile', 'desktop')`
    height: 40px;
    width: 45px;
  `}
`;

export const StyledImage = styled.img`
  width: 300px;
  height: 180px;
  ${({ doctorCard }) => doctorCard && `
    height: 100px;
  `}
 ${breakpoint('mobile', 'desktop')`
   width: 45%;
   padding-bottom: 0rem;
   height: 280px;
  ${({ doctorCard }) => doctorCard && `
    height: 70px;  
     padding-bottom: 1rem;
  `}
 `}
  ${({ first }) => first && `
    padding-bottom: 1rem;
  `}
`;

export const StyledCardImages = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${breakpoint('mobile', 'desktop')`
    flex-direction: row;
    justify-content: space-evenly;
    align-items: stretch;
    ${pt(3)}
  `}
`;

export const StyledGetStarted = styled.button`
  cursor: pointer;
  background-color: white;
  color: black;
  border-radius: 10px;
  padding: 10px 30px;
  font-size: 19px;
  font-weight: 500;
  border: none;
  width: fit-content;
  ${mt(5)};
  ${breakpoint('mobile', 'desktop')`
    ${mt(3)}
    font-size: 15px;
     padding: 10px 20px;
  `}
`;

export const StyledMobileCard = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  justify-content: space-between;
  img {
    width: 100%;
  }
  ${breakpoint('mobile', 'desktop')`
  justify-content: flex-start;
  `}
`;
